import { AppSidebar } from '@/components/app-sidebar'
import { NavUser } from '@/components/nav-user'
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator
} from '@/components/ui/breadcrumb'
import { Separator } from '@/components/ui/separator'
import {
    SidebarInset,
    SidebarProvider,
    SidebarTrigger
} from '@/components/ui/sidebar'
import { useIsMobile } from '@/hooks/use-mobile'
import { useAppSelector } from '@/store/hooks'
import { getAuthInfo } from '@/store/selectors/authSelector'
import { getUiInfo } from '@/store/selectors/uiSelectors'
import { Dictionary } from '@/types/field'
import { ICON_SIZE_2 } from '@/utils/constant'
import { setGlobalNavigate } from '@/utils/globalNavigation.tsx'
import { ChevronLeft } from 'lucide-react'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'

export default function Page() {
    const isMobile = useIsMobile()
    const { pageTitle, mainTitle, mainSlug } = useAppSelector((state: Dictionary) => getUiInfo(state))
    const { isAuth, isLogin } = useAppSelector((state: Dictionary) => getAuthInfo(state))
    const navigate = useNavigate()

    // set global navigate function
    setGlobalNavigate(navigate)

    if (!isAuth || !isLogin) {
        return <Navigate to="/login" />
    }
    return (
        <SidebarProvider className='overflow-x-hidden'>
            <AppSidebar />
            <SidebarInset className='overflow-x-hidden w-full h-[100vh]'>
                <header className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12 bg-sidebar border-b border-color-sidebar-border sticky top-0 z-50">
                    <div className="flex items-center px-2 lg:px-4">
                        <SidebarTrigger className="-ml-1" />
                        <Separator orientation="vertical" className="mr-2 h-4" />
                        <Breadcrumb>
                            <BreadcrumbList>
                                {pageTitle != 'Dashboard' &&
                                    <BreadcrumbItem>
                                        <BreadcrumbLink href="/">{'Dashboard'}</BreadcrumbLink>
                                    </BreadcrumbItem>
                                }
                                {mainTitle && mainTitle != '' &&
                                    <>
                                        <BreadcrumbSeparator />
                                        <BreadcrumbItem>
                                            <BreadcrumbLink onClick={() => navigate(mainSlug)} className="cursor-pointer">{mainTitle}</BreadcrumbLink>
                                        </BreadcrumbItem>
                                    </>
                                }
                                {pageTitle != 'Dashboard' &&
                                    <><BreadcrumbSeparator /><BreadcrumbItem>
                                        <BreadcrumbPage>{pageTitle}</BreadcrumbPage>
                                    </BreadcrumbItem></>}

                            </BreadcrumbList>
                        </Breadcrumb>
                    </div>
                    <div className="ml-auto flex items-center gap-1">
                        <NavUser />
                    </div>
                </header>

                <div className={`${isMobile ? 'p-3' : 'p-10'} w-full flex-1 flex flex-col`}>
                    {/* Header */}
                    <div className="flex items-center mb-4">
                        {mainTitle && (
                            <button
                                onClick={() => navigate(-1)}
                                className="rounded-md hover:bg-gray-100"
                            >
                                <ChevronLeft size={ICON_SIZE_2} />
                            </button>
                        )}
                        <h1 className="scroll-m-20 text-3xl font-bold tracking-tight ml-2">
                            {pageTitle}
                        </h1>
                    </div>

                    {/* Scrollable Content */}
                    <div className="flex-1 overflow-y-auto  rounded-md ">
                        <Outlet />
                    </div>
                </div>
            </SidebarInset>
        </SidebarProvider>
    )
}
